module.exports = __webpack_public_path__ + "img/cancel.9983706c.png";